import styled from "styled-components";

export const HeaderText = styled.p`
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: inherit;
  text-align: center;
`;
